import React, { useState } from 'react';
import DeleteSavedDashboardPopup from './DeleteSavedDashboardPopup';
import { get } from 'lodash';

function DeleteSavedDashboardWrapper({
  pageMeta,
  goToHome,
  onDeleteCallback,
  children,
  disabled = false,
  dashboardTypeName = '',
  isDefaultLandingPage = false,
}: any) {
  const dashboardId = get(pageMeta, ['id'], null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => {
          setIsPopupOpen(true);
        }}
      >
        {children}
      </div>

      <DeleteSavedDashboardPopup
        isPopupOpen={disabled ? false : isPopupOpen}
        closePopup={() => setIsPopupOpen(false)}
        dashboardId={dashboardId}
        goToHome={goToHome}
        onDeleteCallback={onDeleteCallback}
        dashboardTypeName={dashboardTypeName}
        isDefaultLandingPageOverride={isDefaultLandingPage}
      />
    </>
  );
}

export default DeleteSavedDashboardWrapper;
